import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import "../styles/navbar.css"; // pastikan path ini benar

export default function Navbar() {
  const location = useLocation();
  const [activePath, setActivePath] = useState("/");
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentUser, isAdmin } = useAuth();

  useEffect(() => {
    setActivePath(location.pathname);
    setMenuOpen(false); // close menu saat navigasi
  }, [location]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="navbar">
      <div
        className={`nav-overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden={!menuOpen}
      />
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          Ruqyah Syar’i Tegal
        </Link>

        <button
          className={`burger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? "Tutup menu" : "Buka menu"}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <Link
            to="/"
            className={`navitem ${activePath === "/" ? "active" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/blog"
            className={`navitem ${activePath === "/blog" ? "active" : ""}`}
          >
            Blog
          </Link>
          <Link
            to="/berbagi"
            className={`navitem ${activePath.startsWith("/berbagi") ? "active" : ""}`}
          >
            Berbagi Cerita
          </Link>
          <Link
            to={currentUser && isAdmin ? "/admin" : "/login"}
            className={`navitem ${activePath.startsWith("/admin") || activePath === "/login" ? "active" : ""}`}
          >
            {currentUser && isAdmin ? "Admin Panel" : "Login Admin"}
          </Link>
        </nav>
      </div>
    </header>
  );
}
